/**
 * Save constants
 */

// API Action types
export const GET_SAVE_TO_GOV_HISTORY_REQUEST = 'gstr9/Save/GET_SAVE_TO_GOV_HISTORY_REQUEST';
export const GET_SAVE_TO_GOV_HISTORY_SUCCESS = 'gstr9/Save/GET_SAVE_TO_GOV_HISTORY_SUCCESS';
export const GET_SAVE_TO_GOV_HISTORY_FAILURE = 'gstr9/Save/GET_SAVE_TO_GOV_HISTORY_FAILURE';

// Loader status
export const SET_SAVE_LOADER_STATUS = 'gstr9/Save/SET_SAVE_LOADER_STATUS';

// Data management
export const CLEAR_SAVE_HISTORY = 'gstr9/Save/CLEAR_SAVE_HISTORY';

// Pagination
export const SET_SAVE_PAGINATION = 'gstr9/Save/SET_SAVE_PAGINATION';
export const SET_SAVE_PAGE_SIZE = 'gstr9/Save/SET_SAVE_PAGE_SIZE';

// Save to GSTN API
export const SAVE_TO_GSTN_REQUEST = 'gstr9/Save/SAVE_TO_GSTN_REQUEST';
export const SAVE_TO_GSTN_SUCCESS = 'gstr9/Save/SAVE_TO_GSTN_SUCCESS';
export const SAVE_TO_GSTN_FAILURE = 'gstr9/Save/SAVE_TO_GSTN_FAILURE';

// Download JSON API
export const DOWNLOAD_JSON_REQUEST = 'gstr9/Save/DOWNLOAD_JSON_REQUEST';
export const DOWNLOAD_JSON_SUCCESS = 'gstr9/Save/DOWNLOAD_JSON_SUCCESS';
export const DOWNLOAD_JSON_FAILURE = 'gstr9/Save/DOWNLOAD_JSON_FAILURE';

// Fetched Summary API
export const GET_FETCHED_SUMMARY_HISTORY_REQUEST = 'gstr9/Save/GET_FETCHED_SUMMARY_HISTORY_REQUEST';
export const GET_FETCHED_SUMMARY_HISTORY_SUCCESS = 'gstr9/Save/GET_FETCHED_SUMMARY_HISTORY_SUCCESS';
export const GET_FETCHED_SUMMARY_HISTORY_FAILURE = 'gstr9/Save/GET_FETCHED_SUMMARY_HISTORY_FAILURE';

export const SET_FETCHED_SUMMARY_PAGINATION = 'gstr9/Save/SET_FETCHED_SUMMARY_PAGINATION';
export const SET_FETCHED_SUMMARY_PAGE_SIZE = 'gstr9/Save/SET_FETCHED_SUMMARY_PAGE_SIZE';
export const CLEAR_FETCHED_SUMMARY_HISTORY = 'gstr9/Save/CLEAR_FETCHED_SUMMARY_HISTORY';
